<template>
  <div class="notPage_box">
    <img :src="require('@/assets/imgs/404.png')" alt="">
    <div class="backBtn" @click="goback">返回上一页</div>
  </div>
</template>

<script>
export default {
  methods: {
    goback () {
      window.history.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.notPage_box {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.backBtn {
  border: 1px solid #4bcebb;
  border-radius: 15px;
  font-size: 14px;
  padding: 5px 15px;
  background: #4bcebb;
  color: #fff;
  cursor: pointer;
}
</style>